// extracted by mini-css-extract-plugin
module.exports = {"alert":"ErrorBoundary_alert__ScMU5"};